import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/hvac-service-admin",
    name: "HVAC Service Admin",
    component: () => import("./hvacServiceAdmin.vue"),
  },
] satisfies RouteRecordRaw[];
